var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.758 4.094c.159.219.159.531.159 1.156v9.5c0 .625 0 .937-.16 1.156a.8.8 0 0 1-.184.185c-.219.159-.531.159-1.156.159h-.333c-.625 0-.938 0-1.157-.16a.8.8 0 0 1-.184-.184c-.16-.219-.16-.531-.16-1.156v-9.5c0-.625 0-.937.16-1.156a.8.8 0 0 1 .184-.185c.22-.159.532-.159 1.157-.159h.333c.625 0 .937 0 1.156.16q.107.076.185.184m7.5 0c.159.219.159.531.159 1.156v9.5c0 .625 0 .937-.16 1.156a.8.8 0 0 1-.184.185c-.219.159-.531.159-1.156.159h-.333c-.625 0-.938 0-1.157-.16a.8.8 0 0 1-.184-.184c-.16-.219-.16-.531-.16-1.156v-9.5c0-.625 0-.937.16-1.156a.8.8 0 0 1 .184-.185c.22-.159.532-.159 1.157-.159h.333c.625 0 .937 0 1.156.16q.107.076.185.184",
    clipRule: "evenodd"
  })));
};
export default SvgPause;